import {
  billOfMaterialsIdFormat,
  locationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const recordBomProduction = {
  name: "recordBomProduction" as const,
  input: z.object({
    bomId: billOfMaterialsIdFormat.schema,
    quantity: z.number().int().positive().max(10_000),
    locationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({
    success: z.literal(true),
    inputsConsumed: z.number(),
    outputsProduced: z.number(),
  }),
};
